// extracted by mini-css-extract-plugin
export default {"container":"Main_container__RuGvW","button":"Main_button__DhHms","fundsButton":"Main_fundsButton__VTJx2"};